import React from 'react';
import casino from "../../_asset/media/casino2.mp4"
import casino_bg from "../../_asset/media/casino2.png"

function CasinoVideo() {

    const srcUrl = '4w1yS-VtVCw'
    return <div id={"global-video-background"}>
        {/*<video autoPlay={true}*/}
        {/*       muted={true}*/}
        {/*       loop={true}*/}
        {/*       src={casino}></video>*/}
        {/* <iframe src={`https://www.youtube.com/embed/${srcUrl}?si=JQl24tQt9rL2SsTT&controls=0&loop=1&playlist=${srcUrl}&autoplay=1&mute=1`}
                title="YouTube video player" frameBorder="0"
                allow="accelerometer; autoplay; loop; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen></iframe> */}
        {/*<img src={casino_bg} alt=""/>*/}
        {/* <div className={"background-cover"}></div> */}
    </div>;
}

export default CasinoVideo;